import React from 'react';
import { motion } from 'framer-motion';
import { Event } from '../../types/events';
import { Link } from 'react-router-dom';

interface EventListProps {
  events: Event[];
}

const EventList: React.FC<EventListProps> = ({ events }) => {
  return (
    <div className="space-y-4">
      {events.map((event, index) => (
        <motion.div
          key={event.id}
          className="flex items-center bg-gray-800 rounded-lg p-4 hover:bg-gray-700 transition-colors"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
        >
          <img src={event.bannerImage} alt={event.title} className="w-32 h-16 object-cover rounded-md mr-4" />
          <div className="flex-grow">
            <Link to={`/events/${event.id}`}>
              <h3 className="font-bold text-lg hover:underline">{event.title}</h3>
            </Link>
            <p className="text-gray-400">
              {event.startDate.toLocaleDateString()} - {event.endDate.toLocaleDateString()}
            </p>
          </div>
          <div className="text-lg font-bold">
            {/* Rank can be added later */}
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default EventList;
